import React from 'react';

import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { useFormHook } from '../../../hooks';
import { useWizardContext } from './logic/WizardContext';
import { AddressFormStep } from './steps/AddressFormStep';

import { ErrorView } from './steps/ErrorView';
import { createSchema } from './logic/ChangePersonalAddressSchema';
import { useChangeAddressStepHook } from './logic/useStepHook';
import { useHandleSucces as useHandleSuccess } from './logic/useHandleSuccess';
import useStore from '../../../store';
import { ISummaryData } from '../../../types';

export enum ChangePersonalAddressFlow {
  AddressForm,

  // Edit,
  ERROR,
  NONE,
}
export interface ChangePersonalAddressProps {
  onAddressUpdatedSuccessfully: () => void;
}
export const ChangePersonalAddressSteps = ({ onAddressUpdatedSuccessfully }: ChangePersonalAddressProps) => {
  const { step } = useWizardContext();
  const summaryData: ISummaryData = useStore((state) => state.summary);
  // eslint-disable-next-line prefer-destructuring
  const address = summaryData.customer.address;

  const personalAddressFields = {
    street: address?.line1,
    apt: address?.line2,
    city: address?.city,
    state: address?.state,
    zip: address?.postalCode,
  };
  const businessAddressFields = {
    street: null,
    apt: '',
    city: null,
    state: null,
    zip: null,
  };

  const formDefaultValues = businessAddressFields;
  const { t } = useTranslation();

  const changePersonalAddressSchema = createSchema(t);
  const { setError, formMethods } = useFormHook({
    formSchema: changePersonalAddressSchema,
    formDefaultValues,
    schemaTitle: 'change-address',
    mode: 'onBlur',
  });
  const { getValues } = formMethods;
  const { handleErrorCode, customerId } = useChangeAddressStepHook({ setError });

  const { isLoading, handleConfirm } = useHandleSuccess({
    onAddressUpdatedSuccessfully,
    getValues,
    handleErrorCode,
    customerId,
  });

  const renderMap: { [key in ChangePersonalAddressFlow]: React.ReactNode } = {
    [ChangePersonalAddressFlow.AddressForm]: (
      <AddressFormStep
        personalAddressFields={personalAddressFields}
        control={formMethods.control}
        isLoading={isLoading}
        handleConfirm={handleConfirm}
      />
    ),

    // [ChangePersonalAddressFlow.Edit]: (
    //   <EditView isLoading={isLoading} handleClick={handleConfirm} handleEdit={handleEdit} />
    // ),
    [ChangePersonalAddressFlow.ERROR]: <ErrorView onClose={() => {}} />,
    [ChangePersonalAddressFlow.NONE]: <div />,
  };

  return (
    <div>
      <div className='flex flex-col bg-bw01 rounded-[12px] maxHeight-[460px] px-[32px] pt-[32px] pb-[32px] w-[504px] '>
        <div className='flex flex-col justify-center items-center'>
          <FormProvider {...formMethods}>{renderMap[step as ChangePersonalAddressFlow]}</FormProvider>
        </div>
      </div>
    </div>
  );
};
